const defaultCompanies = [];
const groupFilteredCompanies = (state = defaultCompanies, action) => {
  switch (action.type) {
    case 'GROUP_FILTER_COMPANIES_SUCCESS':
      return action.getGroupsFilterCompanies;
    default:
      return state;
  }
};

export default groupFilteredCompanies;
